import { Heart, Code, Sparkles, Linkedin, Github, Mail } from "lucide-react";

const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="relative py-12 px-6 border-t border-border/30 overflow-hidden">
      {/* Animated SVG background */}
      <div className="absolute inset-0 pointer-events-none overflow-hidden">
        {/* Animated circles */}
        <svg className="absolute -bottom-20 -left-20 w-64 h-64 text-primary/5" viewBox="0 0 200 200" aria-hidden="true">
          <circle cx="100" cy="100" r="80" fill="currentColor" className="animate-pulse" />
        </svg>
        <svg className="absolute -bottom-10 -right-10 w-48 h-48 text-accent/5" viewBox="0 0 200 200" aria-hidden="true">
          <circle cx="100" cy="100" r="60" fill="currentColor" className="animate-pulse" style={{ animationDelay: '1s' }} />
        </svg>

        {/* Animated wave */}
        <svg className="absolute bottom-0 left-0 w-full h-24 text-primary/5" preserveAspectRatio="none" viewBox="0 0 1200 120" aria-hidden="true">
          <path
            d="M0,60 C150,120 350,0 600,60 C850,120 1050,0 1200,60 L1200,120 L0,120 Z"
            fill="currentColor"
            className="animate-float-slow"
          />
        </svg>

        {/* Floating particles */}
        {[...Array(5)].map((_, i) => (
          <div
            key={i}
            className="absolute w-1 h-1 bg-primary/20 rounded-full animate-float"
            style={{
              left: `${20 + i * 15}%`,
              bottom: `${30 + (i % 3) * 20}%`,
              animationDelay: `${i * 0.5}s`,
              animationDuration: `${3 + i}s`,
            }}
            aria-hidden="true"
          />
        ))}
      </div>

      <div className="container max-w-6xl mx-auto relative z-10">
        <div className="flex flex-col items-center space-y-6">
          {/* Footer Navigation */}
          <nav aria-label="Footer navigation" className="flex flex-wrap justify-center gap-x-8 gap-y-3 text-sm">
            <a
              href="#about"
              className="text-muted-foreground hover:text-primary transition-colors duration-300"
            >
              About
            </a>
            <a
              href="#projects"
              className="text-muted-foreground hover:text-primary transition-colors duration-300"
            >
              Projects
            </a>
            <a
              href="#experience"
              className="text-muted-foreground hover:text-primary transition-colors duration-300"
            >
              Experience
            </a>
            <a
              href="#contact"
              className="text-muted-foreground hover:text-primary transition-colors duration-300"
            >
              Contact
            </a>
            <a
              href="/sitemap.xml"
              className="text-muted-foreground hover:text-primary transition-colors duration-300"
            >
              Sitemap
            </a>
          </nav>

          {/* Social Links */}
          <div className="flex items-center gap-3">
            <a
              href="https://www.linkedin.com/in/spilios-spiliopoulos-ai-ml/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Spilios Spiliopoulos on LinkedIn"
              className="p-2 rounded-full text-muted-foreground hover:text-primary hover:bg-primary/10 transition-all duration-300 hover:scale-110"
            >
              <Linkedin className="w-5 h-5" />
            </a>
            <a
              href="https://github.com/spiliossp"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Spilios Spiliopoulos on GitHub"
              className="p-2 rounded-full text-muted-foreground hover:text-primary hover:bg-primary/10 transition-all duration-300 hover:scale-110"
            >
              <Github className="w-5 h-5" />
            </a>
            <a
              href="mailto:sphliossp@gmail.com"
              aria-label="Email Spilios Spiliopoulos"
              className="p-2 rounded-full text-muted-foreground hover:text-primary hover:bg-primary/10 transition-all duration-300 hover:scale-110"
            >
              <Mail className="w-5 h-5" />
            </a>
          </div>

          {/* Decorative line */}
          <div className="w-24 h-0.5 bg-gradient-to-r from-transparent via-primary/30 to-transparent" aria-hidden="true" />

          {/* Main footer text */}
          <p className="text-muted-foreground flex items-center gap-2 flex-wrap justify-center text-sm">
            <span>&copy; {year} Spilios Spiliopoulos. All rights reserved.</span>
            <span className="flex items-center gap-1">
              Built with
              <Heart className="w-4 h-4 text-rose-500 animate-pulse inline" aria-hidden="true" />
              and
              <Code className="w-4 h-4 text-primary inline" aria-hidden="true" />
            </span>
          </p>

          {/* Tagline */}
          <p className="text-xs text-muted-foreground/70 flex items-center gap-2">
            <Sparkles className="w-3 h-3 text-accent" aria-hidden="true" />
            Passionate about AI and innovation
            <Sparkles className="w-3 h-3 text-accent" aria-hidden="true" />
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
